/**
 * @generated SignedSource<<a20828c174c8bd8a39e189bc703d5812>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TagUpdatesAsideViewQuery$variables = {
  activeProjectsTql: string;
  completedProjectsTql: string;
  pausedProjectsTql: string;
  pendingProjectsTql: string;
  relatedGoalsTql: string;
  sidebarLimit: number;
  tagUUID?: string | null;
  workspaceUuid: string;
};
export type TagUpdatesAsideViewQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"TagSidebarColumn">;
};
export type TagUpdatesAsideViewQuery = {
  response: TagUpdatesAsideViewQuery$data;
  variables: TagUpdatesAsideViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "activeProjectsTql"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "completedProjectsTql"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pausedProjectsTql"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pendingProjectsTql"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "relatedGoalsTql"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sidebarLimit"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tagUUID"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceUuid"
},
v8 = {
  "kind": "Variable",
  "name": "uuid",
  "variableName": "tagUUID"
},
v9 = {
  "kind": "Variable",
  "name": "workspaceUuid",
  "variableName": "workspaceUuid"
},
v10 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v11 = {
  "kind": "ScalarField",
  "name": "id"
},
v12 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "sidebarLimit"
},
v13 = [
  "LATEST_UPDATE_DATE_DESC"
],
v14 = {
  "kind": "Literal",
  "name": "sort",
  "value": (v13/*: any*/)
},
v15 = {
  "kind": "ScalarField",
  "name": "count"
},
v16 = {
  "kind": "ScalarField",
  "name": "key"
},
v17 = {
  "kind": "ScalarField",
  "name": "name"
},
v18 = {
  "kind": "ScalarField",
  "name": "private"
},
v19 = {
  "concreteType": "IconURIs",
  "kind": "LinkedField",
  "name": "iconUrl",
  "plural": false,
  "selections": [
    {
      "concreteType": "ThemeURIs",
      "kind": "LinkedField",
      "name": "square",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "light"
        },
        {
          "kind": "ScalarField",
          "name": "dark"
        },
        {
          "kind": "ScalarField",
          "name": "transparent"
        }
      ]
    }
  ]
},
v20 = {
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "aaid"
    },
    {
      "concreteType": "UserPII",
      "kind": "LinkedField",
      "name": "pii",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "picture"
        },
        {
          "kind": "ScalarField",
          "name": "accountId"
        }
      ]
    },
    (v11/*: any*/)
  ]
},
v21 = {
  "kind": "ScalarField",
  "name": "label"
},
v22 = {
  "concreteType": "LocalizationField",
  "kind": "LinkedField",
  "name": "localizedLabel",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "messageId"
    }
  ]
},
v23 = {
  "kind": "ScalarField",
  "name": "value"
},
v24 = [
  (v15/*: any*/),
  {
    "concreteType": "ProjectEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "Project",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v11/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v10/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/)
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "name": "TagUpdatesAsideViewQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "activeProjectsTql",
            "variableName": "activeProjectsTql"
          },
          {
            "kind": "Variable",
            "name": "completedProjectsTql",
            "variableName": "completedProjectsTql"
          },
          {
            "kind": "Variable",
            "name": "pausedProjectsTql",
            "variableName": "pausedProjectsTql"
          },
          {
            "kind": "Variable",
            "name": "pendingProjectsTql",
            "variableName": "pendingProjectsTql"
          },
          {
            "kind": "Variable",
            "name": "relatedGoalsTql",
            "variableName": "relatedGoalsTql"
          },
          {
            "kind": "Variable",
            "name": "sidebarLimit",
            "variableName": "sidebarLimit"
          },
          (v8/*: any*/),
          (v9/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "TagSidebarColumn"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v6/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Operation",
    "name": "TagUpdatesAsideViewQuery",
    "selections": [
      {
        "args": [
          (v8/*: any*/)
        ],
        "concreteType": "Tag",
        "kind": "LinkedField",
        "name": "tagByUuid",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          (v11/*: any*/)
        ]
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "tagUuid",
            "variableName": "tagUUID"
          }
        ],
        "concreteType": "StatusSummaryForTag",
        "kind": "LinkedField",
        "name": "projectStatusSummaryForTag",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "atRisk"
          },
          {
            "kind": "ScalarField",
            "name": "onTrack"
          },
          {
            "kind": "ScalarField",
            "name": "offTrack"
          }
        ]
      },
      {
        "alias": "activeProjectsTql",
        "args": [
          (v12/*: any*/),
          {
            "kind": "Variable",
            "name": "q",
            "variableName": "activeProjectsTql"
          },
          (v14/*: any*/),
          (v9/*: any*/)
        ],
        "concreteType": "ProjectConnection",
        "kind": "LinkedField",
        "name": "projectTql",
        "plural": false,
        "selections": [
          (v15/*: any*/),
          {
            "concreteType": "ProjectEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "Project",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v10/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  {
                    "concreteType": "ProjectState",
                    "kind": "LinkedField",
                    "name": "state",
                    "plural": false,
                    "selections": [
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/),
                      {
                        "concreteType": "CompletionProjectState",
                        "kind": "LinkedField",
                        "name": "atCompletionState",
                        "plural": false,
                        "selections": [
                          (v23/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "alias": "pendingProjectsTql",
        "args": [
          (v12/*: any*/),
          {
            "kind": "Variable",
            "name": "q",
            "variableName": "pendingProjectsTql"
          },
          (v14/*: any*/),
          (v9/*: any*/)
        ],
        "concreteType": "ProjectConnection",
        "kind": "LinkedField",
        "name": "projectTql",
        "plural": false,
        "selections": (v24/*: any*/)
      },
      {
        "alias": "pausedProjectsTql",
        "args": [
          (v12/*: any*/),
          {
            "kind": "Variable",
            "name": "q",
            "variableName": "pausedProjectsTql"
          },
          (v14/*: any*/),
          (v9/*: any*/)
        ],
        "concreteType": "ProjectConnection",
        "kind": "LinkedField",
        "name": "projectTql",
        "plural": false,
        "selections": (v24/*: any*/)
      },
      {
        "alias": "completedProjectsTql",
        "args": [
          (v12/*: any*/),
          {
            "kind": "Variable",
            "name": "q",
            "variableName": "completedProjectsTql"
          },
          (v14/*: any*/),
          (v9/*: any*/)
        ],
        "concreteType": "ProjectConnection",
        "kind": "LinkedField",
        "name": "projectTql",
        "plural": false,
        "selections": (v24/*: any*/)
      },
      {
        "alias": "relatedGoalsTql",
        "args": [
          (v12/*: any*/),
          {
            "kind": "Variable",
            "name": "q",
            "variableName": "relatedGoalsTql"
          },
          {
            "kind": "Literal",
            "name": "sorts",
            "value": (v13/*: any*/)
          },
          (v9/*: any*/)
        ],
        "concreteType": "GoalConnection",
        "kind": "LinkedField",
        "name": "goalTql",
        "plural": false,
        "selections": [
          (v15/*: any*/),
          {
            "concreteType": "GoalEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "Goal",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v16/*: any*/),
                  (v10/*: any*/),
                  {
                    "concreteType": "GoalIcon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "appearance"
                      }
                    ]
                  },
                  (v17/*: any*/),
                  (v20/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "7a26cfb379423b0d9d041fb55365eb06",
    "id": null,
    "metadata": {},
    "name": "TagUpdatesAsideViewQuery",
    "operationKind": "query",
    "text": "query TagUpdatesAsideViewQuery(\n  $tagUUID: UUID\n  $activeProjectsTql: String!\n  $pendingProjectsTql: String!\n  $pausedProjectsTql: String!\n  $completedProjectsTql: String!\n  $relatedGoalsTql: String!\n  $sidebarLimit: Int!\n  $workspaceUuid: UUID!\n) {\n  ...TagSidebarColumn_1ngckp\n}\n\nfragment ActiveTagProjectsSection_6txXW on Query {\n  tagByUuid(uuid: $tagUUID) {\n    uuid\n    id\n  }\n  projectStatusSummaryForTag(tagUuid: $tagUUID) {\n    atRisk\n    onTrack\n    offTrack\n  }\n  activeProjectsTql: projectTql(q: $activeProjectsTql, sort: [LATEST_UPDATE_DATE_DESC], first: $sidebarLimit, workspaceUuid: $workspaceUuid) {\n    ...ProjectWithOwnerSidebarSection_1O1zBL\n  }\n}\n\nfragment CompletedTagProjectsSection_4wQXN3 on Query {\n  tagByUuid(uuid: $tagUUID) {\n    uuid\n    id\n  }\n  completedProjectsTql: projectTql(q: $completedProjectsTql, sort: [LATEST_UPDATE_DATE_DESC], first: $sidebarLimit, workspaceUuid: $workspaceUuid) {\n    ...ProjectWithOwnerSidebarSection\n  }\n}\n\nfragment GoalName on Goal {\n  uuid\n  id\n  key\n  ...PlatformGoalIcon\n  name\n}\n\nfragment GoalRowWithOwner on Goal {\n  key\n  ...GoalName\n  owner {\n    ...UserAvatar_2aqwkz\n    id\n  }\n}\n\nfragment GoalWithOwnerSidebarSection on GoalConnection {\n  count\n  edges {\n    node {\n      id\n      ...GoalRowWithOwner\n    }\n  }\n}\n\nfragment PausedTagProjectsSection_1E2a3V on Query {\n  tagByUuid(uuid: $tagUUID) {\n    uuid\n    id\n  }\n  pausedProjectsTql: projectTql(q: $pausedProjectsTql, sort: [LATEST_UPDATE_DATE_DESC], first: $sidebarLimit, workspaceUuid: $workspaceUuid) {\n    ...ProjectWithOwnerSidebarSection\n  }\n}\n\nfragment PendingTagProjectsSection_cFWye on Query {\n  tagByUuid(uuid: $tagUUID) {\n    uuid\n    id\n  }\n  pendingProjectsTql: projectTql(q: $pendingProjectsTql, sort: [LATEST_UPDATE_DATE_DESC], first: $sidebarLimit, workspaceUuid: $workspaceUuid) {\n    ...ProjectWithOwnerSidebarSection\n  }\n}\n\nfragment PlatformGoalIcon on Goal {\n  icon {\n    key\n    appearance\n  }\n}\n\nfragment ProjectIcon on Project {\n  private\n  iconUrl {\n    square {\n      light\n      dark\n      transparent\n    }\n  }\n}\n\nfragment ProjectName_data on Project {\n  id\n  key\n  name\n  uuid\n  ...ProjectIcon\n}\n\nfragment ProjectRowWithOwner_1O1zBL on Project {\n  key\n  ...ProjectName_data\n  owner {\n    ...UserAvatar_2aqwkz\n    id\n  }\n  state {\n    ...ProjectState\n  }\n}\n\nfragment ProjectRowWithOwner_4yoa7g on Project {\n  key\n  ...ProjectName_data\n  owner {\n    ...UserAvatar_2aqwkz\n    id\n  }\n}\n\nfragment ProjectState on ProjectState {\n  label\n  localizedLabel {\n    messageId\n  }\n  value\n  atCompletionState {\n    value\n    label\n    localizedLabel {\n      messageId\n    }\n  }\n}\n\nfragment ProjectWithOwnerSidebarSection on ProjectConnection {\n  count\n  edges {\n    node {\n      id\n      ...ProjectRowWithOwner_4yoa7g\n    }\n  }\n}\n\nfragment ProjectWithOwnerSidebarSection_1O1zBL on ProjectConnection {\n  count\n  edges {\n    node {\n      id\n      ...ProjectRowWithOwner_1O1zBL\n    }\n  }\n}\n\nfragment RelatedTagGoalsSection_1x6H84 on Query {\n  tagByUuid(uuid: $tagUUID) {\n    uuid\n    id\n  }\n  relatedGoalsTql: goalTql(q: $relatedGoalsTql, sorts: [LATEST_UPDATE_DATE_DESC], first: $sidebarLimit, workspaceUuid: $workspaceUuid) {\n    ...GoalWithOwnerSidebarSection\n  }\n}\n\nfragment TagSidebarColumn_1ngckp on Query {\n  ...ActiveTagProjectsSection_6txXW\n  ...PendingTagProjectsSection_cFWye\n  ...PausedTagProjectsSection_1E2a3V\n  ...CompletedTagProjectsSection_4wQXN3\n  ...RelatedTagGoalsSection_1x6H84\n}\n\nfragment UserAvatar_2aqwkz on User {\n  aaid\n  pii {\n    picture\n    accountId\n  }\n}\n"
  }
};
})();

(node as any).hash = "a23b6a6610c4c20a1a8eef0c929a4dfc";

export default node;
